<template>
  <div class="row teaser-section None">
    <div class="teasercontent large-12 columns mobile-column">
      <div class="row">
        <div class="scfForm">
          <div class="campusForm">
            <div>
              <div>
                <fieldset class="scfSectionBorderAsFieldSet">
                  <div class="scfSectionContent">
                    <div class="scfSingleLineTextBorder">
                      <label for="datepicker" class="scfSingleLineTextLabel">
                        {{ getTranslation("camp_date") }}: *
                      </label>
                      <div class="scfSingleLineGeneralPanel">
                        <input id="datepicker" autofocus />
                      </div>
                    </div>

                    <div class="scfSingleLineTextBorder">
                      <label for="fromHour" class="scfSingleLineTextLabel">
                        {{ getTranslation("camp_raum_TimeFrom") }}: *
                      </label>
                      <div class="scfSingleLineGeneralPanel">
                        <input
                          id="fromHour"
                          type="text"
                          v-model="component.fromHour"
                          size="3"
                          maxlength="2"
                          inputmode="numeric"
                          class="scfSingleLineTextBox timeBox"
                          required
                        />
                        :
                        <input
                          id="fromMinute"
                          type="text"
                          v-model="component.fromMinute"
                          size="3"
                          maxlength="2"
                          inputmode="numeric"
                          class="scfSingleLineTextBox timeBox"
                          required
                        />
                      </div>
                    </div>

                    <div class="scfSingleLineTextBorder">
                      <label for="toHour" class="scfSingleLineTextLabel">
                        {{ getTranslation("camp_raum_TimeUntil") }}: *
                      </label>
                      <div class="scfSingleLineGeneralPanel">
                        <input
                          id="toHour"
                          type="text"
                          v-model="component.toHour"
                          size="3"
                          maxlength="2"
                          inputmode="numeric"
                          class="scfSingleLineTextBox timeBox"
                          required
                        />
                        :
                        <input
                          id="toMinute"
                          type="text"
                          v-model="component.toMinute"
                          size="3"
                          maxlength="2"
                          inputmode="numeric"
                          class="scfSingleLineTextBox timeBox"
                          required
                        />
                      </div>
                    </div>

                    <div
                      v-if="model.availableEquipment.length !== 0"
                      class="scfCheckBoxListBorder"
                    >
                      <span class="scfCheckBoxListLabel">
                        {{ getTranslation("camp_raum_Equipment") }}:
                      </span>
                      <div class="scfCheckBoxListGeneralPanel">
                        <table class="scfCheckBoxList">
                          <tr v-for="equipment in model.availableEquipment">
                            <td>
                              <input
                                :id="equipment.key"
                                type="checkbox"
                                :value="equipment.key"
                                v-model="equipment.selected"
                              />
                              <label :for="equipment.key">{{
                                equipment.name
                              }}</label>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="scfDropListBorder">
                      <label for="roomType" class="scfDropListLabel">
                        {{ getTranslation("camp_edu_RaumType") }}:
                      </label>
                      <div class="scfDropListGeneralPanel">
                        <select
                          id="roomType"
                          class="scfDropList regular-drop-down"
                          v-model="component.roomTypeId"
                        >
                          <option value=""></option>
                          <option
                            v-for="option in model.roomTypes"
                            v-bind:value="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="scfSingleLineTextBorder">
                      <label for="numPerson" class="scfSingleLineTextLabel">
                        {{ getTranslation("camp_edu_RaumCountPersonen") }}:
                      </label>
                      <div class="scfSingleLineGeneralPanel">
                        <input
                          id="numPerson"
                          type="text"
                          v-model="component.numPerson"
                          size="3"
                          maxlength="3"
                          inputmode="numeric"
                          class="scfSingleLineTextBox"
                        />
                      </div>
                    </div>

                    <div class="scfDropListBorder">
                      <label for="city" class="scfDropListLabel">
                        {{ getTranslation("camp_raum_Ort") }}:
                      </label>
                      <div class="scfDropListGeneralPanel">
                        <select
                          id="city"
                          class="scfDropList regular-drop-down"
                          v-model="component.city"
                        >
                          <option value=""></option>
                          <option
                            v-for="option in model.cities"
                            v-bind:value="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div
                      v-if="addresses.length !== 0"
                      class="scfDropListBorder"
                    >
                      <label for="address" class="scfDropListLabel">
                        {{ getTranslation("camp_edu_RaumAddress") }}:
                      </label>
                      <div class="scfDropListGeneralPanel">
                        <select
                          id="address"
                          class="scfDropList regular-drop-down"
                          v-model="component.address"
                        >
                          <option value=""></option>
                          <option
                            v-for="option in addresses"
                            v-bind:value="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div v-if="floors.length !== 0" class="scfDropListBorder">
                      <label for="floor" class="scfDropListLabel">
                        {{ getTranslation("camp_edu_RaumStockwerk") }}:
                      </label>
                      <div class="scfDropListGeneralPanel">
                        <select
                          id="floor"
                          class="scfDropList regular-drop-down"
                          v-model="component.floor"
                        >
                          <option value=""></option>
                          <option
                            v-for="option in floors"
                            v-bind:value="option.name"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="scfFooterBorder">
              <p></p>
            </div>

            <div class="scfSubmitButtonBorder">
              <input
                type="submit"
                :value="getTranslation('camp_search')"
                @click.prevent="search"
                class="scfSubmitButton"
              />
              <a href="." class="button">{{
                getTranslation("camp_reset_all")
              }}</a>
            </div>
          </div>
        </div>

        <div
          v-if="component.loading"
          class="loading-icon columns text-center prepend-top noprint"
        >
          <p>
            <img
              src="/Assets/Campus/Common/img/Icons/loading-blue-50x50.gif"
              alt="loading..."
            />
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="component.result"
      class="teasercontent large-16 columns filter-main"
    >
      <div v-if="component.result.entries.length !== 0" class="row">
        <div class="list-information large-20 columns">
          <div class="row">
            <div
              class="
                small-20
                columns
                list-information-inner
                tablet-column
                result-count
              "
            >
              <strong class="count">{{
                component.result.entries.length
              }}</strong>
              <span class="results-found-label">{{
                getTranslation("camp_ListeResultsFound")
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="list-header row prepend-top">
        <div class="tablet-column">
          <label class="medium-3 large-3 widget-title columns hide-for-small">
            {{ getTranslation("camp_raum_SearchResultDateTime") }}
          </label>
          <label class="widget-title medium-11 large-11 columns hide-for-small">
            {{ getTranslation("camp_raum_SearchResultResourcePlace") }}
          </label>
          <label
            class="
              medium-5
              large-5
              widget-title
              columns
              large-offset-1
              hide-for-small
            "
          >
            {{ getTranslation("camp_raum_Action") }}
          </label>
        </div>
      </div>

      <div class="row">
        <div class="filter-list-holder">
          <ul id="fl" class="nav large filter-list columns ul">
            <li
              v-if="component.result.entries.length === 0"
              class="list-item noresults row"
            >
              <header class="tablet-column columns text-center no-outline">
                <p>{{ getTranslation("camp_NoDataFound") }}</p>
              </header>
            </li>

            <ResultEntry
              v-for="entry in component.result.entries"
              :key="entry.roomId"
              :entry="entry"
              :translations="model.translations"
              :bookingUrl="additional.bookingUrl"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RaumResRoomSearch from "../../../_Api/RaumResRoomSearch";
import ResultEntry from "./components/ResultEntry.vue";

export default {
  components: {
    ResultEntry,
  },
  data() {
    return {
      model: {
        department: null,
        availableEquipment: null,
        roomTypes: null,
        cities: null,
        translations: null,
      },
      additional: {
        bookingUrl: null,
      },
      component: {
        fromHour: null,
        fromMinute: "00",
        toHour: null,
        toMinute: "00",
        roomTypeId: null,
        numPerson: null,
        city: null,
        address: null,
        floor: null,
        loading: false,
        result: null,
      },
    };
  },
  created() {
    let data = this.$parent.$data;
    this.model = data.model;
    this.additional = data.additional;
  },
  mounted() {
    this.initDatePicker();
    this.initFields();
  },
  methods: {
    initDatePicker() {
      if (HSLU.language === "de") {
        kendo.culture("de-CH");
      }

      var today = new Date();
      var todayStr = kendo.format("{0:d}", today);

      $("#datepicker").kendoDatePicker({
        value: todayStr,
        min: today,
      });
    },
    initFields() {
      if (this.model.cities.length === 1) {
        this.component.city = this.model.cities[0].name;
      }
      if (this.addresses.length === 1) {
        this.component.address = this.addresses[0].name;
      }
    },
    getDateFromDatePicker() {
      var datePickerVal = $("#datepicker").val();
      var date = kendo.parseDate(datePickerVal);
      return date;
    },
    getSelectedEquipmentKeys() {
      var list = [];
      for (var i = 0; i < this.model.availableEquipment.length; i++) {
        var equipment = this.model.availableEquipment[i];
        if (equipment.selected) {
          list.push(equipment.key);
        }
      }
      return list;
    },
    search() {
      var date = this.getDateFromDatePicker();
      if (!date) {
        var msg = this.getTranslation("camp_no_valid_date_selected");
        dialogError(msg);
        return;
      }
      if (
        !this.component.fromHour ||
        !this.component.fromMinute ||
        !this.component.toHour ||
        !this.component.toMinute
      ) {
        var msg = this.getTranslation("camp_RequiredFieldMessageBox");
        dialogError(msg);
        return;
      }
      var equipmentKeys = this.getSelectedEquipmentKeys();
      var query = {
        department: this.model.department,
        date: date.toISOString(),
        fromHour: this.component.fromHour,
        fromMinute: this.component.fromMinute,
        toHour: this.component.toHour,
        toMinute: this.component.toMinute,
        equipment: equipmentKeys,
        roomTypeId: this.component.roomTypeId,
        numPerson: this.component.numPerson,
        city: this.component.city,
        address: this.component.address,
        floor: this.component.floor,
      };
      this.component.result = null;
      this.component.loading = true;
      RaumResRoomSearch.searchRoom(
        query,
        this.searchSuccess,
        this.searchFailure
      );
    },
    getTranslation(key) {
      return this.model.translations[key];
    },
    searchSuccess(data) {
      if (data.successful) {
        this.component.result = data;
        this.component.loading = false;
      } else {
        dialogError(data.message);
      }
    },
    searchFailure(status) {
      dialogError("Es ist ein Fehler aufgetreten: Status-Code " + status);
    },
    getCityFromModel(cityName) {
      for (var i = 0; i < this.model.cities.length; i++) {
        var city = this.model.cities[i];
        if (city.name != cityName) {
          continue;
        }
        return city;
      }
      return null;
    },
  },
  computed: {
    addresses: function () {
      var cityName = this.component.city;
      var city = this.getCityFromModel(cityName);
      if (!city) {
        return [];
      }
      return city.addresses;
    },
    floors: function () {
      var cityName = this.component.city;
      var city = this.getCityFromModel(cityName);
      if (!city) {
        return [];
      }
      for (var i = 0; i < city.addresses.length; i++) {
        var address = city.addresses[i];
        if (address.name != this.component.address) {
          continue;
        }
        return address.floors;
      }
      return [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "~/Assets/Campus/Common/sass/colors";
.k-picker-wrap {
  .k-input {
    border: none !important;
    border-radius: 0px !important;
    color: $black !important;
    padding: 0.2rem 0.5rem !important;
    height: 2.5rem !important;
  }
}
.timeBox {
  width: auto !important;
  display: inline !important;
}

input:required:invalid {
  border-color: $medium-magenta;
}

.scfDropListGeneralPanel {
  margin-bottom: 0;
}

.regular-drop-down {
  border: 1px solid $black;
  border-radius: 0px;
  color: $black;
  padding: 0.2rem 0.5rem;
  height: 2.5rem;
  &:focus-visible,
  &:focus{
      border: 1px solid $medium-blue; 
      outline: none;
  }
}
</style>